import { LoginScreen } from "@src/components/modules/auth/login-screen";
import { NoIndexHead } from "@src/components/widgets/NoIndexHead/NoIndexHead";
import { createFileRoute } from "@tanstack/react-router";

const Login = () => {
  return (
    <>
      <NoIndexHead />
      <LoginScreen />
    </>
  );
};
export const Route = createFileRoute("/login")({
  component: Login,
});
